import React from 'react';
import { motion } from 'framer-motion';
import { Package, Bell, User, Settings, LogOut } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';
import { useAppStore } from '../../stores/appStore';
import { useNavigate } from 'react-router-dom';

export const Header: React.FC = () => {
  const { user, signOut } = useAuthStore();
  const { notifications } = useAppStore();
  const navigate = useNavigate();
  
  const unreadCount = notifications.filter(n => !n.read).length;

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40 safe-area-top">
      <div className="px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="w-10 h-10 sm:w-12 sm:h-12 bg-saavi-500 rounded-lg flex items-center justify-center"
            >
              <Package className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </motion.div>
            
            <div>
              <h1 className="text-lg sm:text-xl font-semibold text-gray-900">
                Mojo Pick
              </h1>
              <p className="text-xs sm:text-sm text-gray-500 truncate max-w-32 sm:max-w-none">
                {user?.email || 'Not signed in'}
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 sm:space-x-3">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="relative p-2 sm:p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg touch-manipulation"
            >
              <Bell className="w-5 h-5 sm:w-6 sm:h-6 text-saavi-600" />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 w-4 h-4 sm:w-5 sm:h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="p-2 sm:p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg touch-manipulation"
            >
              <Settings className="w-5 h-5 sm:w-6 sm:h-6 text-saavi-600" />
            </motion.button>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleSignOut}
              className="p-2 sm:p-3 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg touch-manipulation"
              title="Sign Out"
            >
              <LogOut className="w-5 h-5 sm:w-6 sm:h-6" />
            </motion.button>
          </div>
        </div>
      </div>
    </header>
  );
};